import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import { NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactTooltip from "react-tooltip";
import './NavMenu.css';
import NotificationBadge from 'react-notification-badge';
import { WHATSAPP_LIVE_CHAT } from '../../routes/routes';

class TopNavItem extends React.PureComponent<any, any> {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    public render() {
        let item = <NavbarBrand tag={Link} to="/#" onClick={this.props.handleOnClick} data-tip={this.props.tooltip} className={"ssp-topmenu-item-a " + this.props.cssClass}>
            <Image src={this.props.image} alt={this.props.alt} />
            <div className="ssp-topmenu-item-block" title={this.props.title}>
                <div className="ssp-topnav-icon-container">
                    <div className="ssp-topnav-icon"></div>
                </div>
                <div className="ssp-topnav-icon-text">
                    {this.props.navIconNameMobileOnly &&
                        <>
                            <span className="ismobile">{this.props.navIconNameMobileOnly}</span>
                            <span className="desktoponly">{this.props.navIconName}</span>
                        </>
                    }
                    {!this.props.navIconNameMobileOnly &&
                        <>
                            {this.props.navIconName}
                        </>
                    }
                </div>
            </div>

            <div className="notifcationBadge">
                <NotificationBadge count={parseInt(this.props.count)} />
            </div>
            <ReactTooltip place="bottom" effect="solid" backgroundColor="#3a1826" arrowColor="transparent" delayShow={1000} />
        </NavbarBrand>

        if (this.props.href === WHATSAPP_LIVE_CHAT) {
            item = <a target="_blank" rel="noopener noreferrer" href={WHATSAPP_LIVE_CHAT} data-tip={this.props.tooltip} className={"justify-content-center navbar-expand-sm navbar-toggleable-sm box-shadow nav inline h-100 " + this.props.cssClass}>
                <Image src={this.props.image} alt={this.props.alt} />
                <div className="notifcationBadge">
                    <NotificationBadge count={parseInt(this.props.count)} />
                </div>
                <ReactTooltip place="bottom" effect="solid" backgroundColor="#3a1826" arrowColor="transparent" delayShow={1000} />
            </a>
        }

        return (
            <>
                {item}
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(TopNavItem)